import { LegalLayout } from '../components/LegalLayout';

export const MembershipAgreement = () => {
    return (
        <LegalLayout title="Membership Agreement" lastUpdated="December 28, 2025">
            <p className="intro-text">
                This Membership Agreement ("Agreement") governs your purchase and use of the Nostavia Health membership and related services.
            </p>

            <section>
                <h2>1. Membership Tiers and Benefits</h2>
                <p>
                    Nostavia Health offers distinct membership tiers (e.g., Baseline, Pro, Ultimate).
                </p>
                <ul>
                    <li><strong>Baseline:</strong> Includes bi-annual testing, essential reporting, and basic recommendations.</li>
                    <li><strong>Pro:</strong> Includes quarterly testing, advanced reporting, and priority support.</li>
                    <li><strong>Ultimate:</strong> Includes comprehensive testing, full concierge service, and maximum data granularity.</li>
                </ul>
                <p>Specific benefits are subject to change. We will notify you of any material reduction in benefits.</p>
            </section>

            <section>
                <h2>2. Membership Term and Renewal</h2>
                <p>
                    <strong>Automatic Renewal:</strong> Your membership typically operates on a recurring basis (monthly or annually). It will <strong>automatically renew</strong> at the end of each billing cycle for the same duration unless you cancel it before the renewal date.
                </p>
                <p>
                    You authorize us to charge your payment method on file for the renewal term at the then-current rate.
                </p>
            </section>

            <section>
                <h2>3. Fees and Billing</h2>
                <p>
                    You agree to pay all fees associated with your selected membership tier. All fees are in the currency specified at checkout.
                </p>
                <ul>
                    <li>You must provide a current, valid, and accepted payment method.</li>
                    <li>If a payment is not successfully settled, we may suspend your access to the Services until we have obtained a valid payment method.</li>
                </ul>
            </section>

            <section>
                <h2>4. Cancellation and Refunds</h2>
                <p>
                    <strong>Cancellation:</strong> You may cancel your membership at any time through your account settings or by contacting support.
                </p>
                <p>
                    <strong>Effect of Cancellation:</strong> Cancellation will be effective at the end of your current billing period. You will continue to have access to the Services until the end of that period.
                </p>
                <p>
                    <strong>Refund Policy:</strong> Payments are generally non-refundable and there are no credits for partially used periods, except as required by applicable law or as explicitly stated in a specific promotional offer.
                </p>
            </section>

            <section>
                <h2>5. Changes to the Agreement</h2>
                <p>
                    We may change this Agreement from time to time. If we make material changes, we will provide you with notice as appropriate under the circumstances, e.g., by displaying a prominent notice within the Service or by sending you an email.
                </p>
            </section>

            <section>
                <h2>6. Termination by Nostavia</h2>
                <p>
                    We may terminate or suspend your membership immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms of Service or this Agreement.
                </p>
            </section>
        </LegalLayout>
    );
};
